import dashboardIT from './dashboard';
import menuAboutIT from './menuAbout';
import labelsIT from './labels';
import releasesIT from './releases';
import artistsIT from './artists';
import artistsWishlistIT from './artistsWishlist';
import profileIT from './profile';
import musicLinksIT from './musicLinks';
import linkLandingPagesIT from './linkLandingPages';
import masteringIT from './mastering';
import featureIT from './feature';
import accountingIT from './accounting';
import paymentMethodsIT from './paymentMethods';
import purchaseHistoryIT from './purchaseHistory';
import trendsIT from './trends';
import earningsDrilldownIT from './earningsDrilldown';
import invoicesIT from './invoices';
import statementsIT from './statements';
import subuserStatementsIT from './subuserStatements';
import userDataFormIT from './userDataForm';
import creditsIT from './credits';
import disputeClaimsIT from './disputeClaims';
import musicLinkUrlPartsIT from './musicLinkUrlParts';
import subscriptionIT from './subscription';
import twoFactorAuthIT from './twoFactorAuth';
import generalIT from './general';
import routerIT from './router';
import escrowWalletIT from './escrowWallet';
import subUsersIT from './subUsers';
import tokensIT from './tokens';
import tracksIT from './tracks';
import acrAlertIT from './acrAlert';
import qcNoteIT from './qcNote';
import flaggedContentIT from './flaggedContent';
import deliveryConfirmationIT from './deliveryConfirmation';
import preScanIT from './preScan';
import accessKeysIT from './accessKeys';
import announcementsIT from './announcements';

const translationIT = {
    'router': routerIT,
    'general': generalIT,
    'dashboard': dashboardIT,
    'menuAbout': menuAboutIT,
    'labels': labelsIT,
    'artists': artistsIT,
    'artistsWishlist': artistsWishlistIT,
    'releases': releasesIT,
    'tracks': tracksIT,
    'profile': profileIT,
    'musicLinks': musicLinksIT,
    'musicLinkUrlParts': musicLinkUrlPartsIT,
    'linkLandingPages': linkLandingPagesIT,
    'mastering': masteringIT,
    'feature': featureIT,
    'accounting': accountingIT,
    'paymentMethods': paymentMethodsIT,
    'purchaseHistory': purchaseHistoryIT,
    'trends': trendsIT,
    'earningsDrilldown': earningsDrilldownIT,
    'invoices': invoicesIT,
    'statements': statementsIT,
    'subuserStatements': subuserStatementsIT,
    'credits': creditsIT,
    'userDataForm': userDataFormIT,
    'disputeClaims': disputeClaimsIT,
    'subscription': subscriptionIT,
    'twoFactorAuth': twoFactorAuthIT,
    'escrowWallet': escrowWalletIT,
    'subUsers': subUsersIT,
    'tokens': tokensIT,
    'acrAlert': acrAlertIT,
    'qcNote': qcNoteIT,
    'flaggedContent': flaggedContentIT,
    'deliveryConfirmation': deliveryConfirmationIT,
    'preScan': preScanIT,
    'accessKeys': accessKeysIT,
    'announcements': announcementsIT,
};

export default translationIT;
